import PropTypes from 'prop-types';
import Image from '@plone/volto/components/theme/Image/Image';
import {
  homepageImageSources,
  listItemsNeedNormalization,
  normalizeObjectList,
} from '../../../helpers/homepageUtils';

const EpisodeContent = ({ episode, side }) => {
  const image = homepageImageSources(episode.image, {
    minWidth: 400,
    fallback: 'preview',
  });
  const containerClass =
    side === 'left'
      ? 'history-episode-left-container'
      : 'history-episode-right-container';

  return (
    <div className={containerClass}>
      {image.src ? (
        <div className="history-episode-img">
          <Image
            src={image.src}
            srcSet={image.srcSet}
            sizes="(max-width: 768px) 100vw, 50vw"
            width={image.width}
            height={image.height}
            alt=""
            loading="lazy"
          />
        </div>
      ) : null}
      <p className="history-episode-year">{episode.year}</p>
      <p className="history-episode-text">{episode.text}</p>
    </div>
  );
};

EpisodeContent.propTypes = {
  episode: PropTypes.objectOf(PropTypes.any).isRequired,
  side: PropTypes.oneOf(['left', 'right']).isRequired,
};

const TimelineBody = ({ episodes = [] }) => {
  const normalizedEpisodes = listItemsNeedNormalization(episodes)
    ? normalizeObjectList(episodes)
    : episodes;

  return (
    <div className="csj-timeline">
      <div className="history-episodes-container">
        <div className="history-episodes-left-container">
          {normalizedEpisodes.map((episode, index) =>
            index % 2 ? (
              <EpisodeContent
                key={episode['@id'] || index}
                episode={episode}
                side="left"
              />
            ) : null,
          )}
        </div>
        <div className="history-vertical-separator" />
        <div className="history-episodes-right-container">
          {normalizedEpisodes.map((episode, index) =>
            index % 2 ? null : (
              <EpisodeContent
                key={episode['@id'] || index}
                episode={episode}
                side="right"
              />
            ),
          )}
        </div>
      </div>
    </div>
  );
};

TimelineBody.propTypes = {
  episodes: PropTypes.arrayOf(PropTypes.object),
};

export default TimelineBody;
